var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonalExams(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 6V10.172C14 10.702 14.211 11.211 14.586 11.586L19.414 16.414C19.789 16.789 20 17.298 20 17.828V19C20 20.105 19.105 21 18 21H6C4.895 21 4 20.105 4 19V17.828C4 17.298 4.211 16.789 4.586 16.414L9.414 11.586C9.789 11.211 10 10.702 10 10.172V6",
    stroke: "#4DACC2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 3H14C14.552 3 15 3.448 15 4V5C15 5.552 14.552 6 14 6H10C9.448 6 9 5.552 9 5V4C9 3.448 9.448 3 10 3Z",
    stroke: "#4DACC2",
    strokeWidth: 1.6599,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.18005 17H19.8201",
    stroke: "#4DACC2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.81995 11H14.1799",
    stroke: "#4DACC2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalExams);
export default __webpack_public_path__ + "static/media/personal-exams.c5829e38c0aaf2afc18e95d9ecf1e415.svg";
export { ForwardRef as ReactComponent };